import type { Customer } from "@/types";

export function generateAddressStringDotSeparator(customer: Customer): string {
  if (!customer) return '';

  const addressParts = [
    customer.address + (customer.address2 ? ` ${customer.address2}` : ''), // Concatenate address and address2 without separator
    `${customer.zip} ${customer.city}`,
  ];

  // Filter out any undefined or empty parts and join with a separator
  return addressParts.filter(Boolean).join(' · ');
}